import React from 'react';
import {useStyles} from './helper';
import clsx from 'clsx';
import { useSelector } from 'react-redux';
import Button from '../button';
import {useRouter} from '../../../../@casino/useRouter';
import DatePicker from '../datePicker';

const TemplatePage = ({title, children, handleLoadPagination, handleLoading, backUrl, datePicker, changeDate, search, searchValue, onChangeSearch}) => {
    const classes = useStyles();
    const router = useRouter();

    const loading = useSelector(state => state.templateMobile.loading);
    
    const onScroll = (e) => {
        const scroll = e.target.documentElement.scrollHeight - e.target.documentElement.scrollTop;
        const end = e.target.documentElement.clientHeight + 80;

        if (scroll < end && !loading) {
            handleLoading()
            handleLoadPagination()
            window.removeEventListener('scroll', onScroll)
        }
    }
    
    React.useEffect(() => {
        if (loading === false && handleLoading) {
            window.addEventListener('scroll', onScroll);
        }
        // eslint-disable-next-line
    }, [loading]);

    return (
        <div className={classes.root}>
            <div className={classes.wrap}>
                <span className={classes.title}>{title}</span>
            </div>
            {
                backUrl && 
                <div className={classes.mb12}>
                    <Button title="Назад" onClick={() => router.history.push('/support/list')}/>
                </div>
            }
            {
                datePicker &&
                <div>
                    <DatePicker changeDate={changeDate}/>
                </div>
            }
            {
                search &&
                <div className={classes.wrapBlock}>  
                    <input 
                        type="text"
                        placeholder="Поиск"
                        className={classes.search}
                        value={searchValue}
                        onChange={(v) => {
                            onChangeSearch(v.target.value)
                        }}
                    />
                </div>
            }
            
            <div className={clsx(classes.wrap, classes.flexColumn, classes.p0)}>
                {children}
            </div>
        </div>
    )
}

export default TemplatePage;